import { render, staticRenderFns } from "./BaseFrontOfficeButtonIcon.vue?vue&type=template&id=27659e0d&scoped=true"
import script from "./BaseFrontOfficeButtonIcon.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeButtonIcon.vue?vue&type=style&index=0&id=27659e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27659e0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
